var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4142 3.82837C21.4142 3.27608 20.9665 2.82837 20.4142 2.82837H15.5858C15.0335 2.82837 14.5858 3.27608 14.5858 3.82837C14.5858 4.38065 15.0335 4.82837 15.5858 4.82837L18 4.82837L11.4645 11.3639C11.0739 11.7544 11.0739 12.3876 11.4645 12.7781C11.855 13.1686 12.4882 13.1686 12.8787 12.7781L19.4142 6.24258V8.6568C19.4142 9.20908 19.8619 9.6568 20.4142 9.6568C20.9665 9.6568 21.4142 9.20908 21.4142 8.6568V3.82837Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.99994C6.34315 4.99994 5 6.34309 5 7.99994V15.9999C5 17.6568 6.34315 18.9999 8 18.9999H16C17.6569 18.9999 19 17.6568 19 15.9999V13.9999C19 13.4477 19.4477 12.9999 20 12.9999C20.5523 12.9999 21 13.4477 21 13.9999V15.9999C21 18.7614 18.7614 20.9999 16 20.9999H8C5.23858 20.9999 3 18.7614 3 15.9999V7.99994C3 5.23852 5.23858 2.99994 8 2.99994H10C10.5523 2.99994 11 3.44766 11 3.99994C11 4.55223 10.5523 4.99994 10 4.99994H8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.9d9031306418408414bbbd4aee61bad0.svg";
export { ForwardRef as ReactComponent };